export default "__VITE_ASSET__eAWMY9OW__"